module.exports = __webpack_public_path__ + "img/98.5dbe1946.jpg";